/* eslint-disable @nx/enforce-module-boundaries */
import { Component, Input, OnInit } from '@angular/core';
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import { ShellTrackHandlers } from '@cigna/cigna-for-brokers/shared/analytics-util';
@Component({
  selector: 'cigna-brk-statement-access-request',
  templateUrl: './statement-access-request.component.html',
  styleUrls: ['./statement-access-request.component.scss'],
})
export class StatementAccessRequestComponent implements OnInit {
  @Input() isFromHome: boolean;
  @Input() isImpersonatorFlag: boolean;
  constructor(
    public _appStateFacade: AppstateFacade,
    public analytics: ShellTrackHandlers,
  ) {}

  ngOnInit(): void {
    if (this.isFromHome) {
      this._appStateFacade.setStatementAccessRequest(true);
    }
  }
  trackLinkClick(): void {
    if (this.isFromHome && !this.isImpersonatorFlag) {
      this.analytics.trackEventOther({}, 'email', 'ac24429', {
        eVar119: 'MTD-1439',
        eVar120: 'compensation-links',
        prop67: 'action',
        channel: 'Home',
        prop51: 'U.S. Employer',
        prop20: 'compensation',
        pageName: 'Dashboard',
      });
    } else {
      if (!this.isImpersonatorFlag) {
        this.analytics.trackEventOther({}, 'email', 'ac24433', {
          eVar119: 'MTD-1450',
          eVar120: 'request-statement-access-modal-links',
          prop20: 'request statement access modal',
          prop67: 'action',
          channel: 'Home',
          pageName: 'Dashboard',
        });
      }
    }
  }
}
